
const auth = {
  'auth.signIn': 'Iniciar sesión',
  'auth.signUp': 'Registrarse',
  'auth.signOut': 'Cerrar sesión',
  'auth.profile': 'Perfil',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.resetPassword': 'Restablecer contraseña',
  'auth.noAccount': '¿No tienes una cuenta?',
  'auth.haveAccount': '¿Ya tienes una cuenta?',
  'auth.emailVerification': 'Verificación de correo electrónico',
  'auth.emailVerificationSent': 'Se ha enviado un correo de verificación a tu dirección de correo electrónico. Por favor, revisa tu bandeja de entrada y sigue las instrucciones para verificar tu cuenta.',
  'auth.emailVerificationInfo': 'Antes de poder iniciar sesión, por favor verifica tu dirección de correo electrónico.',
  'auth.verificationSuccess': '¡Tu correo electrónico ha sido verificado exitosamente!',
  'auth.verificationError': 'Hubo un error al verificar tu correo electrónico.',
  'auth.passwordRequirements': 'La contraseña debe:',
  'auth.passwordLength': 'Tener al menos 8 caracteres',
  'auth.passwordUppercase': 'Incluir al menos una letra mayúscula',
  'auth.passwordLowercase': 'Incluir al menos una letra minúscula',
  'auth.passwordNumber': 'Incluir al menos un número',
  'auth.passwordSpecial': 'Incluir al menos un carácter especial',
  'auth.passwordsDoNotMatch': 'Las contraseñas no coinciden',
  'auth.emailsDoNotMatch': 'Los correos electrónicos no coinciden',
  'auth.invalidEmail': 'Por favor introduce una dirección de correo electrónico válida',
  'auth.mandatoryField': 'Este campo es obligatorio',
  'auth.usernameLength': 'El nombre de usuario debe tener entre 3 y 20 caracteres',
  'auth.usernameFormat': 'El nombre de usuario solo puede contener letras, números, guiones bajos y guiones',
  'auth.nameFormat': 'Solo puede contener letras, espacios, guiones y apóstrofes',
  'auth.nameMaxLength': 'No debe exceder los 50 caracteres',
  'auth.phoneFormat': 'Por favor introduce un número de teléfono válido',
  'auth.addressFormat': 'La dirección contiene caracteres no válidos',
  'auth.addressMaxLength': 'La dirección no debe exceder los 200 caracteres',
  'auth.cityFormat': 'La ciudad solo puede contener letras, espacios, guiones y apóstrofes',
  'auth.cityMaxLength': 'La ciudad no debe exceder los 100 caracteres',
  'auth.postalCodeFormat': 'El código postal solo puede contener letras, números, espacios y guiones',
  'auth.postalCodeMaxLength': 'El código postal no debe exceder los 20 caracteres',
  'auth.emailMaxLength': 'La dirección de correo electrónico es demasiado larga',
  'auth.passwordMaxLength': 'La contraseña no debe exceder los 128 caracteres',
  'auth.phoneMinLength': 'El número de teléfono es demasiado corto',
  'auth.phoneMaxLength': 'El número de teléfono es demasiado largo',
  'auth.suspiciousContent': 'Contiene contenido potencialmente dañino',
  'auth.reservedUsername': 'El nombre de usuario está reservado',
  'auth.commonPassword': 'La contraseña es demasiado común',
  'auth.minimumAge': 'Debes tener al menos 18 años',
  'auth.loginError': 'Correo electrónico o contraseña no válidos',
  'auth.loginRequired': 'Por favor inicia sesión para ver tu perfil',
  'auth.signUpError': 'Error al crear la cuenta',
  'auth.signOutError': 'Error al cerrar sesión',
  'auth.usernameTaken': 'El nombre de usuario ya está en uso',
  'auth.emailTaken': 'El correo electrónico ya está en uso',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellido',
  'auth.dateOfBirth': 'Fecha de nacimiento',
  'auth.gender': 'Género',
  'auth.selectGender': 'Seleccionar género',
  'auth.male': 'Hombre',
  'auth.female': 'Mujer',
  'auth.other': 'Otro',
  'auth.preferNotToSay': 'Prefiero no decirlo',
  'auth.phone': 'Número de teléfono',
  'auth.phoneNumber': 'Número de teléfono',
  'auth.email': 'Correo electrónico',
  'auth.confirmEmail': 'Confirmar correo electrónico',
  'auth.username': 'Nombre de usuario',
  'auth.password': 'Contraseña',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.agreeToTerms': 'Acepto los ',
  'auth.termsOfService': 'Términos de servicio',
  'auth.and': ' y ',
  'auth.privacyPolicy': 'Política de privacidad',
  'auth.termsRequired': 'Debes aceptar los Términos y Condiciones',
  'auth.country': 'País',
  'auth.selectCountry': 'Seleccionar país',
  'auth.countryCode': 'Código de país',
  'auth.selectCountryCode': 'Seleccionar código de país',
  'auth.userInfo': 'Información del usuario',
  'auth.contactInfo': 'Información de contacto',
  'auth.accountInfo': 'Información de la cuenta',
  'auth.welcomeBack': 'Inicia sesión en The Club',
  'auth.welcomeMessage': 'Por favor introduce tus credenciales para iniciar sesión',
  'auth.createAccount': 'Crea tu cuenta de The Club',
  'auth.createAccountMessage': 'Completa la siguiente información para crear tu cuenta',
  'auth.updateProfile': 'Actualizar perfil',
  'auth.profileUpdated': 'Perfil actualizado exitosamente',
  'auth.profileUpdateError': 'Error al actualizar el perfil',
  'auth.selectDate': 'Selecciona una fecha',
  'auth.selectYear': 'Selecciona un año',
  
  // New translations for password reset
  'auth.resetPasswordInstructions': 'Introduce tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
  'auth.sendResetEmail': 'Enviar correo de restablecimiento',
  'auth.resetEmailSent': 'Correo de restablecimiento enviado',
  'auth.resetEmailInstructions': 'Por favor revisa tu correo electrónico para obtener instrucciones para restablecer tu contraseña.',
  'auth.resetPasswordError': 'Error al restablecer la contraseña',
  'auth.unexpectedError': 'Ocurrió un error inesperado',
  'auth.createNewPassword': 'Crea una nueva contraseña para tu cuenta',
  'auth.newPassword': 'Nueva contraseña',
  'auth.backToSignIn': 'Volver a iniciar sesión',
  'auth.passwordResetSuccess': 'Contraseña restablecida exitosamente',
  'auth.passwordResetSuccessMessage': 'Tu contraseña ha sido restablecida exitosamente. Serás redirigido a la página de inicio de sesión.',
  'auth.invalidResetLink': 'Enlace de restablecimiento inválido o caducado',
  'auth.tooManyAttempts': 'Demasiados intentos de inicio de sesión. Por favor intenta de nuevo más tarde.',
  
  // New translations for multi-step signup
  'auth.signUpWithGoogle': 'Regístrate con Google',
  'auth.signUpWithFacebook': 'Regístrate con Facebook',
  'auth.orContinueWithEmail': 'O continúa con correo electrónico',
  'auth.next': 'Siguiente',
  'auth.back': 'Atrás',
  'auth.stepTwoOfTwo': 'Paso 2 de 2',
  
  // New translations for missing UI elements
  'auth.redirecting': 'Redirigiendo...',
  'auth.emailPlaceholder': 'tu@ejemplo.com',
  'auth.emailPlaceholderGeneric': 'correo@ejemplo.com',
  'auth.invalidRecoveryLink': 'Enlace de recuperación inválido. Por favor solicita un nuevo enlace de restablecimiento de contraseña.',
  'auth.passwordResetTitle': 'Restablece tu contraseña',
  'auth.confirmNewPassword': 'Confirmar nueva contraseña',
  'auth.resetPasswordSubmit': 'Restablecer contraseña',

  // Additional validation messages
  'auth.emailValidationError': 'Por favor introduce una dirección de correo electrónico válida',
  'auth.passwordValidationMinLength': 'La contraseña debe tener al menos 8 caracteres',
  'auth.passwordValidationUppercase': 'La contraseña debe incluir al menos una letra mayúscula',
  'auth.passwordValidationNumber': 'La contraseña debe incluir al menos un número',
  'auth.passwordValidationSpecial': 'La contraseña debe incluir al menos un carácter especial',
  'auth.passwordValidationMatch': 'Las contraseñas no coinciden',

  // Reset password specific messages
  'auth.verifyingRecoveryLink': 'Verificando enlace de recuperación...',
  'auth.unableToVerifySession': 'No se puede verificar la sesión de recuperación. Por favor solicita un nuevo enlace de restablecimiento de contraseña.',
  'auth.unableToVerifyLink': 'No se puede verificar el enlace de recuperación. Por favor solicita un nuevo enlace de restablecimiento de contraseña.',
  'auth.invalidRecoverySession': 'Sesión de recuperación inválida. Por favor solicita un nuevo enlace de restablecimiento de contraseña.',
  'auth.requestNewResetLink': 'Solicitar nuevo enlace de restablecimiento',

  // General UI messages
  'auth.emailVerifiedSignIn': 'Tu correo electrónico ha sido verificado. Por favor inicia sesión con tus credenciales.',
  'auth.unexpectedErrorOccurred': 'Ocurrió un error inesperado',
  
  //Supabase Error Messages
  // Authentication errors
  'auth.supabase.invalidCredentials': 'Email o contraseña inválidos',
  'auth.supabase.emailNotConfirmed': 'Verifica tu dirección de email antes de iniciar sesión',
  'auth.supabase.userNotFound': 'No se encontró una cuenta con este email',
  'auth.supabase.passwordTooShort': 'La contraseña debe tener al menos 6 caracteres',
  'auth.supabase.userAlreadyRegistered': 'Ya existe una cuenta con este email',
  'auth.supabase.emailRateLimit': 'Demasiados emails enviados. Espera antes de solicitar otro',
  'auth.supabase.invalidEmail': 'Ingresa una dirección de email válida',
  'auth.supabase.signupDisabled': 'El registro de nuevas cuentas está deshabilitado',
  'auth.supabase.invalidRecoveryToken': 'Enlace de recuperación de contraseña inválido',
  'auth.supabase.tokenExpired': 'Este enlace ha expirado. Solicita un nuevo restablecimiento de contraseña',
  'auth.supabase.passwordTooWeak': 'La contraseña es muy débil. Elige una contraseña más fuerte',
  
  // Database errors
  'auth.supabase.databaseError': 'Error de conexión a la base de datos. Inténtalo más tarde',
  'auth.supabase.connectionTimeout': 'Tiempo de conexión agotado. Verifica tu conexión a internet',
  'auth.supabase.internalError': 'Error interno del servidor. Inténtalo más tarde',
  'auth.supabase.serviceUnavailable': 'Servicio temporalmente no disponible. Inténtalo más tarde',
  'auth.supabase.requestTimeout': 'Tiempo de solicitud agotado. Inténtalo de nuevo',
  
  // Policy/Permission errors
  'auth.supabase.permissionDenied': 'Acceso denegado. No tienes permisos para realizar esta acción',
  'auth.supabase.accessDenied': 'Acceso denegado',
  'auth.supabase.insufficientPermissions': 'Permisos insuficientes para completar esta acción',
  
  // Network errors
  'auth.supabase.networkError': 'Error de conexión de red. Verifica tu conexión a internet',
  'auth.supabase.connectionError': 'Error de conexión. Inténtalo de nuevo',
  
  // Generic patterns
  'auth.supabase.rateLimit': 'Demasiadas solicitudes. Espera un momento antes de intentar de nuevo',
  'auth.supabase.invalidToken': 'Token de autenticación inválido. Inicia sesión nuevamente',
  'auth.supabase.resourceNotFound': 'Recurso solicitado no encontrado',
  'auth.supabase.resourceAlreadyExists': 'Este recurso ya existe',
  
  // Generic fallback
  'auth.supabase.genericError': 'Ocurrió un error inesperado. Inténtalo de nuevo',

  // Invitation code field
  'auth.sponsor': 'Código de Invitación',
  'auth.sponsorMandatory': '(obligatorio)',
  'auth.sponsorPlaceholder': 'Ingresa tu código de invitación',
  'auth.sponsorNotFound': 'Código de invitación no válido. Ingresa un código válido',
  'auth.sponsorRequired': 'Se requiere un código de invitación válido',
  'auth.needSponsor': '¿Necesitas un código de invitación? Contacta a un representante de The Club',

  // Email confirmation error
  'auth.confirmationFailed': 'La confirmación del correo electrónico falló. Por favor revisa tu bandeja de entrada para el último enlace de confirmación.',
  'auth.resendConfirmationEmail': 'Reenviar correo de confirmación',
  'auth.resendIn': 'Reenviar en {{seconds}}',
  'auth.resendSuccess': '¡Correo de confirmación enviado! Por favor revisa tu bandeja de entrada.',
  'auth.enterEmailToResend': 'Ingresa tu correo electrónico para reenviar el enlace de confirmación',

  // Smart confirmation flow
  'auth.emailNeedsConfirmation': 'Este correo necesita ser confirmado. Un enlace de confirmación fue enviado recientemente — por favor revisa tu bandeja de entrada.',
  'auth.emailConfirmationResent': 'Este correo necesita ser confirmado. Se ha enviado un nuevo correo de confirmación — por favor revisa tu bandeja de entrada para el enlace más reciente.',
  'auth.confirmationRecentlySent': 'Un enlace de confirmación fue enviado recientemente a este correo. Por favor revisa tu bandeja de entrada.',
  'auth.confirmationNewSent': 'Se ha enviado un nuevo correo de confirmación. Por favor revisa tu bandeja de entrada para el enlace de confirmación más reciente.',
  'auth.confirmationSentTo': 'Correo de confirmación enviado a:',
  'auth.verifyEmailResendInfo': '¿No recibiste el correo?',

  // Already confirmed messages
  'auth.emailAlreadyConfirmed': 'Tu dirección de correo electrónico ya está verificada. Puedes iniciar sesión con tus credenciales.',
  'auth.emailAlreadyConfirmedSignIn': 'Tu correo ya está verificado. Por favor inicia sesión abajo.',
};

export default auth;
